export default __webpack_public_path__ + "static/white-grey-desserto-5cbc111d55c6f8fdb8466101d63995fa.jpg";